import { Text, useColorMode } from '@tonic-one/react';
import { Select as AntSelect, Tag as AntTag } from 'antd';
const { Option } = AntSelect;

const tagStyle = { margin: '4px 3px 4px 6px', padding: '3px 8px 3px 8px' };

const SelectTag = (props: any) => {
  const {
    width = '400px',
    options = [],
    placeholder = '',
    //eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => {},
    fieldNames = {
      label: 'label',
      value: 'value',
      options: 'options',
    },
    //eslint-disable-next-line @typescript-eslint/no-empty-function
    rule = () => {},
    selections = [],
    inputError = false,
  } = props;
  const [colorMode] = useColorMode();
  const tagBackgroundColor = {
    dark: '#424242',
    light: '#f2f2f2',
  }[colorMode];
  const errorTagBackgroundColor = {
    dark: '#f24c4f',
    light: '#e52630',
  }[colorMode];
  const textColor = {
    dark: '#e0e0e0',
    light: '#303030',
  }[colorMode];
  const dropdownBackgroundColor = {
    dark: '#303030',
    light: '#e0e0e0',
  }[colorMode];
  const tagRender = (props: any) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: any) => {
      event.preventDefault();
      event.stopPropagation();
    };
    let valid = true;
    if (rule && !rule(value)) {
      valid = false;
    }
    if (valid) {
      return (
        <AntTag
          color={tagBackgroundColor}
          key={value}
          onMouseDown={onPreventMouseDown}
          closable={closable}
          onClose={onClose}
          style={{ ...tagStyle, color: textColor }}
        >
          {label}
        </AntTag>
      );
    } else {
      return (
        <AntTag
          color={errorTagBackgroundColor}
          key={value}
          className="select-tag-error"
          onMouseDown={onPreventMouseDown}
          closable={closable}
          onClose={onClose}
          style={{ ...tagStyle, color: textColor }}
        >
          {label}
        </AntTag>
      );
    }
  };
  return (
    <AntSelect
      mode="tags"
      // labelInValue={true}
      optionFilterProp="label"
      optionLabelProp="label"
      style={{ width }}
      placeholder={placeholder}
      // fieldNames={fieldNames}
      // options={options}
      className={inputError ? 'hasError' : ''}
      onChange={onChange}
      tagRender={tagRender}
      maxTagTextLength={20}
      value={selections}
    >
      {options.map((item: any) => {
        return (
          <Option
            key={item[fieldNames.value]}
            value={item[fieldNames.value]}
            label={item[fieldNames.label]}
            style={{
              backgroundColor: dropdownBackgroundColor,
            }}
          >
            <Text color={textColor}>{item[fieldNames.value]}</Text>
          </Option>
        );
      })}
    </AntSelect>
  );
};

export default SelectTag;
